import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-[hsl(165_37%_17%/0.1)] bg-[hsl(42_30%_94%)]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-1">
            <span className="font-serif-display text-2xl" style={{ color: "hsl(165 37% 17%)" }}>New Day</span>
            <span className="font-serif-display text-2xl italic" style={{ color: "hsl(10 51% 55%)" }}>Stays</span>
          </div>
          <p className="mt-4 text-sm text-[hsl(100_3%_30%)] leading-relaxed max-w-xs">
            A small, curated collection of villas and guest houses in Goa and Bangalore. Owner-operated. Warmly hosted.
          </p>
        </div>
        <div>
          <h4 className="font-serif-display text-lg mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/search?location=Goa" className="hover:text-[hsl(10_51%_55%)]">Villas in Goa</Link></li>
            <li><Link to="/search?location=Bangalore" className="hover:text-[hsl(10_51%_55%)]">Stays in Bangalore</Link></li>
            <li><Link to="/search" className="hover:text-[hsl(10_51%_55%)]">All properties</Link></li>
            <li><Link to="/contact" className="hover:text-[hsl(10_51%_55%)]">Concierge</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif-display text-lg mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/contact" className="hover:text-[hsl(10_51%_55%)]">Contact</Link></li>
            <li><Link to="/cancellation-policy" className="hover:text-[hsl(10_51%_55%)]" data-testid="footer-cancellation">Cancellation Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[hsl(10_51%_55%)]" data-testid="footer-terms">Terms</Link></li>
            <li><Link to="/privacy" className="hover:text-[hsl(10_51%_55%)]" data-testid="footer-privacy">Privacy</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif-display text-lg mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm text-[hsl(100_3%_30%)]">
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 mt-0.5" /> Goa · Bangalore, India</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4" /> +91 63607 34483</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4" /> newdaystay@gmail.com</li>
            <li className="flex items-center gap-2"><Instagram className="h-4 w-4" /> @newdaystays</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[hsl(165_37%_17%/0.1)]">
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-6 text-xs text-[hsl(100_3%_30%)] flex flex-col sm:flex-row items-center justify-between gap-3">
          <p>© {new Date().getFullYear()} NewDayStays Hospitality. All rights reserved.</p>
          <p>Made with care in India</p>
        </div>
      </div>
    </footer>
  );
}
